import { BlogSection } from '@/types/blog';

export const ausblickSection: BlogSection = {
  id: 'ausblick',
  title: 'Ein Blick nach vorn',
  content: `
    <p>
      Finnland zeigt, dass Medienkompetenz schon in der Grundschule gelehrt werden kann. Kinder können lernen, Informationen zu prüfen und ihre Gefühle zu benennen. Das ist keine Utopie. Es ist möglich, wenn wir es ernst nehmen.
    </p>

    <div class="mt-8 p-4 bg-joerg-50 rounded-lg border-l-4 border-primary">
      <p class="text-sm text-joerg-600 italic">
        <strong>Hinweis:</strong> Dieser Artikel wurde zuerst auf LinkedIn veröffentlicht. Diskutieren Sie dort gerne mit mir in den Kommentaren.
      </p>
    </div>
  `
};
